/* eslint-disable no-promise-executor-return */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
const MAX_CAPTURE_TIMEOUT_MS = 6000; // wait for 6s before sending whatever vitals we've collected
const FPS_MONITOR_DELAY_MS = 1000; // wait for 1s before starting FPS monitor
const FPS_MONITOR_DURATION_MS = 3000; // monitor FPS for 3s
function waitFor(ms) {
    return _waitFor.apply(this, arguments);
}
function _waitFor() {
    _waitFor = _async_to_generator(function*(ms) {
        return new Promise((resolve)=>setTimeout(resolve, ms));
    });
    return _waitFor.apply(this, arguments);
}
export function captureWebVitals(which) {
    return _captureWebVitals.apply(this, arguments);
}
function _captureWebVitals() {
    _captureWebVitals = _async_to_generator(function*(which) {
        // Note that many vitals metrics (e.g. LCP+CLS) will not report until the user
        // has interacted with the page, switched tabs, or the page starts to unload.
        const { onTTFB } = yield import('web-vitals');
        const result = {
            ttfb: null,
            fps: null
        };
        const promises = [];
        if (which.ttfb) {
            promises.push(new Promise((resolve)=>onTTFB((m)=>{
                    result.ttfb = m.value;
                    resolve();
                })));
        }
        if (which.fps) {
            promises.push(waitFor(FPS_MONITOR_DELAY_MS).then(()=>computeFPS({
                    duration: FPS_MONITOR_DURATION_MS
                })).then((data)=>{
                result.fps = data.average;
            }));
        }
        // Only wait for a little while before sending what we have.  This is necessary
        // because LCP/CLS can take a long time to report, and we don't want to block too
        // long because the user could bail
        yield Promise.race([
            Promise.all(promises),
            waitFor(MAX_CAPTURE_TIMEOUT_MS)
        ]);
        return result;
    });
    return _captureWebVitals.apply(this, arguments);
}
function computeFPS(_) {
    return _computeFPS.apply(this, arguments);
}
function _computeFPS() {
    _computeFPS = _async_to_generator(function*({ duration }) {
        return new Promise((resolve)=>{
            let frames = 0;
            const startTime = performance.now();
            function step(timestamp) {
                frames += 1;
                if (timestamp - startTime < duration) {
                    requestAnimationFrame(step);
                } else {
                    const elapsed = (timestamp - startTime) / 1000;
                    resolve({
                        average: frames / elapsed
                    });
                }
            }
            requestAnimationFrame(step);
        });
    });
    return _computeFPS.apply(this, arguments);
}

//# sourceMappingURL=webVitals.js.map